<template>
  <div class="_root">
    <div class="logo-box acea-row">
      <img class="logo" src="@assets/images/icon/register-logo.png" alt="" />
      <img class="text" src="@assets/images/icon/register-text.png" alt="" />
    </div>
    <div class="form-box">
      <div class="item-form">
        <div class="acea-row row-middle">
          <i class="iconfont icon-phone_"></i>
          <span>手机号</span>
        </div>
        <div class="acea-row _mar-top-10">
          <input
            class="item-input"
            type="number"
			v-model="account"
            placeholder="请输入手机号..."
          />
        </div>
      </div>
      <div class="item-form">
        <div class="acea-row row-middle">
          <i class="iconfont icon-code_"></i>
          <span>短信验证码</span>
        </div>
        <div class="acea-row row-between _mar-top-10">
          <input
            style="width: 3.74rem"
            class="item-input"
            type="number"
            placeholder="请输入验证码..."
			 v-model="captcha"
          />
		  <button
		    class="item-btn"
		    :disabled="disabled"
		    :class="disabled === true ? 'on' : ''"
		    @click="code"
		  >
		    {{ text }}
		  </button>
          
        </div>
      </div>
      <!-- <div class="item-form">
        <div class="acea-row row-middle">
          <i class="iconfont icon-code_"></i>
          <span>密码</span>
        </div>
        <div class="acea-row _mar-top-10">
          <input
            class="item-input"
            type="password"
            placeholder="请输入密码..."
          />
        </div>
      </div>
      <div class="item-form">
        <div class="acea-row row-middle">
          <i class="iconfont icon-code_"></i>
          <span>确认密码</span>
        </div>
        <div class="acea-row _mar-top-10">
          <input
            class="item-input"
            type="password"
            placeholder="请再次输入密码..."
          />
        </div>
      </div> -->
      <div class="item-form">
        <div class="acea-row row-middle">
          <i class="iconfont icon-phone_"></i>
          <span>推荐人手机号</span>
		  <div style="flex: 1;text-align: right;color:#b18a67">{{inviter_show}}</div>
        </div>
        <!-- <div class="acea-row _mar-top-10">
          <input class="item-input" type="number" v-model="inviter" placeholder="请输入..." />
        </div> -->
      </div>
    </div>
    <div class="btn" @click="register()">注册</div>
  </div>
</template>

<script>
	import sendVerifyCode from "@mixins/SendVerifyCode";
	import {
	  login,
	  loginMobile,
	  registerVerify,
	  register,
	  getCodeApi,
	  getSpread,
	} from "@api/user";
	import attrs, { required, alpha_num, chs_phone } from "@utils/validate";
	import { validatorDefaultCatch } from "@utils/dialog";
	import { getLogo } from "@api/public";
	import cookie from "@utils/store/cookie";
	import { VUE_APP_API_URL } from "@utils";
	const BACK_URL = "login_back_url";
export default {
	name: "Login",
	mixins: [sendVerifyCode],
	data: function() {
	  return {
	    navList: ["账号登录", "快速登录"],
	    current: 1,
	    account: "",
	    password: "",
	    captcha: "",
	    formItem: 1,
	    type: "login",
	    logoUrl: "",
	    keyCode: "",
	    codeUrl: "",
	    codeVal: "",
	    isShowCode: false,
		disabled:false,
		inviter:'' ,
		spreadInfo:{},
		inviter_show:'',
	  };
	},
	mounted:function() {
		this.getSpreadInfo();
	},
	methods: {
		
		getSpreadInfo(){
			let that = this;
			if(cookie.get("spread")){
				let id = cookie.get("spread")
				getSpread(id).then(res=>{
					that.spreadInfo = res.data;
					that.inviter = res.data.phone
					let phone = res.data.phone;
					that.inviter_show = phone.replace(/(\d{3})\d{4}(\d{4})/, "$1****$2");
					console.log(that.inviter_show );
				})
			}
		},
		async register() {
		  var that = this;
		  const { account, captcha, password } = that;
		  try {
		    await that
		      .$validator({
		        account: [
		          required(required.message("手机号码")),
		          chs_phone(chs_phone.message())
		        ],
		        captcha: [
		          required(required.message("验证码")),
		          alpha_num(alpha_num.message("验证码"))
		        ],
		        // password: [
		        //   required(required.message("密码")),
		        //   attrs.range([6, 16], attrs.range.message("密码")),
		        //   alpha_num(alpha_num.message("密码"))
		        // ]
		      })
		      .validate({ account, captcha });
		  } catch (e) {
		    return validatorDefaultCatch(e);
		  }
		  let openid =  cookie.get("openid");
		  console.log(openid);
		  register({
		    account: that.account,
		    captcha: that.captcha,
		    password: that.password,
		    // spread: cookie.get("spread"),
			inviter: that.inviter,
			openid: openid,
		  })
		    .then(res => {
		      that.$dialog.success(res.msg);
			  const backUrl = cookie.get(BACK_URL) || "/";
			  cookie.remove(BACK_URL);
			  that.$router.replace({ path: backUrl });
		      // that.formItem = 1;
		    })
		    .catch(res => {
		      that.$dialog.error(res.msg);
		    });
		},
		async code() {
		  var that = this;
		  const { account } = that;
		  try {
		    await that
		      .$validator({
		        account: [
		          required(required.message("手机号码")),
		          chs_phone(chs_phone.message())
		        ]
		      })
		      .validate({ account });
		  } catch (e) {
		    return validatorDefaultCatch(e);
		  }
		  if (that.formItem == 2) that.type = "register";
		  await registerVerify({
		    phone: that.account,
		    type: that.type,
		    key: that.keyCode,
		    code: that.codeVal
		  }).then(res => {
		      that.$dialog.success(res.msg);
		      that.sendCode();
		    })
		    .catch(res => {
		      if (res.data.status === 402) {
		        that.codeUrl = `${VUE_APP_API_URL}/sms_captcha?key=${that.keyCode}`;
		        that.isShowCode = true;
		      }
		      that.$dialog.error(res.msg);
		    });
		},
	},
};
</script>

<style lang="scss" scoped>
._root {
  min-height: 100vh;
  background: rgb(255, 249, 239);
  padding-bottom: 1.88rem;
}
.logo-box {
  padding: 1.04rem 0.78rem 0;
  .logo {
    width: 0.98rem;
    height: 0.98rem;
    margin-right: 0.22rem;
  }
  .text {
    width: 3.48rem;
    height: 0.72rem;
    margin-top: 0.12rem;
  }
}
.form-box {
  margin-top: 0.6rem;
  padding: 0 0.92rem;
  .item-form {
    margin-bottom: 0.4rem;
    .iconfont {
      font-size: 0.3rem;
      margin-right: 0.06rem;
    }
    span {
      font-size: 0.28rem;
    }
    .item-input {
      flex: 1;
      background: #fff;
      height: 0.84rem;
      border-radius: 2rem;
      padding: 0 0.32rem;
    }
    .item-btn {
      width: 1.7rem;
      height: 0.84rem;
      line-height: 0.84rem;
      border-radius: 2rem;
      background-color: rgba(177, 138, 103, 0.21);
      color: rgba(177, 138, 103, 1);
      font-size: 0.28rem;
      text-align: center;
      margin-left: 0.22rem;
    }
  }
}
.btn {
  width: 5.66rem;
  height: 0.8rem;
  line-height: 0.8rem;
  border-radius: 2rem;
  background-color: rgba(177, 138, 103, 1);
  color: rgba(255, 255, 255, 1);
  font-size: 0.28rem;
  text-align: center;
  margin: 0.48rem auto 0;
}
</style>